/* eslint-disable no-use-before-define */

import React from 'react'
import { hideModal, show, Flyout, format } from '../twd'
import { mediaQueries } from '../media-queries'
import { Loader } from './issuer/loader'

export default ({
    issuer,
    className="btn-label link-button text-left",
    dataName="bond-issuer-link",
    cusip, offers, from,
    showBackLink='Y',
    showTradeHistory='N',
    showBondDetail='',
    isTreasuryAuction=false,
}  = {}) => {
    return <React.Fragment>
        {isTreasuryAuction && <React.Fragment>
            <div className={"text-left"}>
            <span style={{display:'inline'}}>{issuer || format.empty()}</span>
            </div>
        </React.Fragment>}
        {!isTreasuryAuction && <Flyout
            html={<Loader {...{cusip, offers, showTradeHistory, showBackLink, showBondDetail, isTreasuryAuction, from}} />}
            trigger={["hover"]}
            isButton={false}
            className={className}
            dataName={dataName}
            showIcon={false}
            contentStyle={{maxWidth:'600px', width:'fit-content'}}
            popperStyles={{
                maxWidth:`${Math.min(mediaQueries.width()-40, 600)}px`,
            }}
            label={issuer || format.empty() }
            onClick={() => {
                hideModal()
                show('bond-detail', { cusip, showBackLink, from })
            }}

        />}
    </React.Fragment>
}
